import { useMemo } from 'react'
import { useAtomValue } from 'jotai'
import { selectAtom } from 'jotai/utils'
import { ConversationTurnState } from '../../../model/StatsAssistant'
import { IDLE_TURN_STATE, statsAssistantTurnsAtom } from '../../../state/statsAssistant'

/** État du tour d'une conversation : ne re-rend que sur les events de cette conversation. */
export const useConversationTurn = (conversationUlid: string | null): ConversationTurnState => {
  const turnAtom = useMemo(
    () =>
      selectAtom(
        statsAssistantTurnsAtom,
        (turns) => (conversationUlid ? turns[conversationUlid] : undefined) ?? IDLE_TURN_STATE,
      ),
    [conversationUlid],
  )

  return useAtomValue(turnAtom)
}
